import { BarChart } from "@msuite/ui/charts";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { getAttendanceWorksiteColor } from "@msuite/utils/attendances";
import { calculateTimeBySeconds, getCalculatedTimeString, moment } from "@msuite/utils/date";
import { useMemo } from "react";
import { useAttendancesHistory } from "@/hooks/use-attendances-history";

/** Props Interface */
interface AttendancesChartProps {
	userId: string;
}

export function AttendancesChart({ userId }: AttendancesChartProps) {
	/** Hooks */
	const { t } = useTranslation();
	const query = useAttendancesHistory(userId);

	const chartData = useMemo(() => {
		return query.history.map((historyItem) => {
			return {
				name: moment(historyItem.date).db(),
				homeOffice: historyItem.homeOffice,
				office: historyItem.office,
				commute: historyItem.commute,
				projectSite: historyItem.projectSite,
				warehouse: historyItem.warehouse,
			};
		});
	}, [query.history]);

	/** Render */
	return (
		<ContentCard
			icon={icon("BarChart")}
			title={t("users.last_30_days")}
			contentClassName="min-h-[350px]"
		>
			<BarChart
				data={chartData}
				dataKeys={["homeOffice", "office", "warehouse", "commute", "projectSite"]}
				displayKeyMap={{
					homeOffice: t("users.worksite_type.home_office"),
					office: t("users.worksite_type.office"),
					warehouse: t("users.worksite_type.warehouse"),
					commute: t("users.worksite_type.commute"),
					projectSite: t("users.worksite_type.project_site"),
				}}
				dataKeyClasses={{
					homeOffice: getAttendanceWorksiteColor("home-office") as any,
					office: getAttendanceWorksiteColor("office") as any,
					warehouse: getAttendanceWorksiteColor("warehouse") as any,
					commute: getAttendanceWorksiteColor("commute") as any,
					projectSite: getAttendanceWorksiteColor("project-site") as any,
				}}
				isStack
				formatter={(item) => getCalculatedTimeString(calculateTimeBySeconds(item))}
				xTickFormatter={(item) => {
					return moment(item.name).format("DD");
				}}
			/>
		</ContentCard>
	);
}
